import {
  GET_SECURITIES,
  GET_SECURITIES_SUCCESS,
  GET_SECURITIES_FAILURE,
  GET_SECURITY,
  GET_SECURITY_SUCCESS,
  GET_SECURITY_FAILURE,
} from './constants';

// Get Securities
export const getSecurities = () => ({
  type: GET_SECURITIES,
  payload: { },
});

export const getSecuritiesSuccess = (securities) => ({
  type: GET_SECURITIES_SUCCESS,
  payload: securities,
});

export const getSecuritiesFailure = (error) => ({
  type: GET_SECURITIES_FAILURE,
  payload: { message: error },
});

// Get Security
export const getSecurity = (securityId) => ({
  type: GET_SECURITY,
  payload: { securityId },
});

export const getSecuritySuccess = (security) => ({
  type: GET_SECURITY_SUCCESS,
  payload: security,
});

export const getSecurityFailure = (error) => ({
  type: GET_SECURITY_FAILURE,
  payload: { message: error },
});